// import React, { Fragment, useState, useEffect, useRef } from "react";
// import { Container, Row, Col, Modal } from "react-bootstrap";
// import Form from "react-bootstrap/Form"; 

// import ReCAPTCHA from "react-google-recaptcha";

// import * as apiUrl from "../../apiUrl";

// function BecomeAgentForm() {
//   const [BecomeAgentForm, setBecomeAgentForm] = useState([]);

//   const [captchaToken, setCaptchaToken] = useState(null);
//   const [formData, setFormData] = useState({
//     firstName: "",
//     lastName: "",
//     email: "",
//     mobile: "",
//     city: "",
//     country: "",
//     message: "",
//     hearAboutUs: "", 
//   });
//   const [errors, setErrors] = useState({});
//   const [showModal, setShowModal] = useState(false);

//   const captchaRef = useRef(null);

//   useEffect(() => {
//     const fetchBecomeAgentForm = async () => {
//       try {
//         const response = await fetch(
//           apiUrl.apiUrl + `/api/become-agent/brokers-form-section`
//         );
//         if (!response.ok) {
//           throw new Error("Failed to fetch data");
//         }
//         const data = await response.json();
//         setBecomeAgentForm(data);
//       } catch (error) {
//         console.error("Error fetching data:", error);
//       }
//     };

//     fetchBecomeAgentForm();
//   }, []);

  
//   const validateField = (fieldName, value) => {
//     const namePattern = /^[A-Za-z\s]+$/;
//     const mobilePattern = /^[0-9]+$/;
//     let error = "";

//     switch (fieldName) {
//       case "firstName":
//         if (!value) error = "Please enter your First Name.";
//         else if (!namePattern.test(value))
//           error = "First Name should only contain letters.";
//         break;

//       case "lastName":
//         if (!value) error = "Please enter your Last Name.";
//         else if (!namePattern.test(value))
//           error = "Last Name should only contain letters.";
//         break;

//       case "email":
//         if (!value) error = "Please enter your Email.";
//         else if (!/\S+@\S+\.\S+/.test(value)) error = "Email is invalid.";
//         break;

//       case "mobile":
//         if (!value) error = "Please enter your Mobile Number.";
//         else if (!mobilePattern.test(value) || value.length < 10)
//           error =
//             "Mobile Number should only contain numbers and be at least 10 digits.";
//         break;

//       case "city":
//         if (!value) error = "Please enter your City.";
//         else if (!namePattern.test(value))
//           error = "City should only contain letters.";
//         break;

//       case "country":
//         if (!value) error = "Please select a Country.";
//         break;

//       case "message":
//         if (!value) error = "Please enter a Message.";
//         break;

//       case "hearAboutUs":
//         if (!value) error = "Please select where you heard about us.";
//         break;
//       case "captchaToken":
//         if (!value) error = "Please Select the CAPTCHA.";
//         break;

//       default:
//         break;
//     }

//     setErrors((prevErrors) => ({ ...prevErrors, [fieldName]: error }));
//   };

//   const handleBlur = (e) => {
//     const { name, value } = e.target;
//     validateField(name, value);
//   };

//   const handleCaptchaChange = (token) => {
//     setCaptchaToken(token);
//   };

//   const handleNameChange = (e) => {
//     const { name, value } = e.target;
//     const namePattern = /^[A-Za-z\s]*$/;

//     if (namePattern.test(value)) {
//       setFormData((prev) => ({ ...prev, [name]: value }));
//     }
//   };

//   const handleMobileChange = (e) => {
//     const { value } = e.target;
//     const mobilePattern = /^[0-9]*$/;

//     if (mobilePattern.test(value)) {
//       setFormData((prev) => ({ ...prev, mobile: value }));
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();   
 
//     // Validate all fields
//     let isValid = true;
//     Object.keys(formData).forEach((key) => {
//       validateField(key, formData[key]);
//       if (errors[key]) {
//         isValid = false;
//       }
//     });

//     // Validate reCAPTCHA last
//     if (!formData.captchaToken) {
//       setErrors((prev) => ({
//         ...prev,
//         captchaToken: "Please Select the CAPTCHA.",
//       }));
//       isValid = false;
//     }

//     if (!isValid) return;

//     try {
//       const formDataObj = new FormData();
//       formDataObj.append("firstName", formData.firstName);
//       formDataObj.append("lastName", formData.lastName);
//       formDataObj.append("email", formData.email);
//       formDataObj.append("mobile", formData.mobile);
//       formDataObj.append("message", formData.message);
//       formDataObj.append("city", formData.city);
//      formDataObj.append("hearAboutUs", formData.hearAboutUs);
//       formDataObj.append("country", formData.country);
//       formDataObj.append("captchaToken", formData.captchaToken);

//       const response = await fetch(apiUrl.apiUrl + `/api/agent/submit`, {
//         method: "POST",        
//         body: formDataObj,
//       });
//       const result = await response.json();
//       if (result.success) {
//         setShowModal(true);
//         setFormData({
//           firstName: "",
//           lastName: "",
//           email: "",
//           mobile: "",
//           city: "",
//           country: "",
//           message: "",
//           hearAboutUs: "", 
//           captchaToken: "",
//         });

//         if (captchaRef.current) {
//           captchaRef.current.reset();
//         }

//         setCaptchaToken(null);
//         localStorage.removeItem("captchaToken");
//       }
//     } catch (error) {
//       console.error("Error submitting form:", error);
//     }
//   };

//   const handleChange = (e) =>
//     setFormData({ ...formData, [e.target.name]: e.target.value });

//   const handleCloseModal = () => setShowModal(false);

//   return (
//     <Fragment>
//       <section className="career-inner-desc-sec become-agent-form-sec">
//         <Container fluid>
//           <Row className="flex-center career-inner-desc-row">
//             <Col md={6} className="padding-zero">
//               <div className="career-inner-content-div">
//                 <h2 className="common-head goldenColor">
//                   {BecomeAgentForm.section_title}
//                 </h2>
//                 <p className="common-para">
//                   {BecomeAgentForm.section_description}​
//                 </p>               
//                   <img
//                     src={`${apiUrl.apiUrl}/${BecomeAgentForm.section_image}`}
//                     className="img-fluid career-side-img"
//                     alt="Partner with us"
//                   />                
//               </div>
//             </Col>
//             <Col md={6}>
//               <div className="career-inner-form-div">
//                 <Form onSubmit={handleSubmit}>
//                   <Row>
//                     <Form.Group
//                       className="col-md-12 mb-3"
//                       controlId="exampleForm.ControlInput1"
//                     >
//                       <Form.Control
//                         type="text"
//                         name="firstName"
//                         placeholder="First Name"
//                         value={formData.firstName}
//                         onChange={handleNameChange}                       
//                         onBlur={handleBlur}
//                       />                     
//                       {errors.firstName && (
//                         <p className="error">{errors.firstName}</p>
//                       )}
//                     </Form.Group>
//                   </Row>
//                   <Row>
//                     <Form.Group
//                       className="col-md-12 mb-3"
//                       controlId="exampleForm.ControlInput2"
//                     >
//                       <Form.Control
//                         type="text"
//                         name="lastName"
//                         placeholder="Last Name"
//                         value={formData.lastName}
//                         onChange={handleNameChange}                        
//                         onBlur={handleBlur}
//                       />                     
//                       {errors.lastName && (
//                         <p className="error">{errors.lastName}</p>
//                       )}
//                     </Form.Group>
//                   </Row>
//                   <Row>
//                     <Form.Group
//                       className="col-md-12 mb-3"
//                       controlId="exampleForm.ControlInput3"
//                     >
//                       <Form.Control
//                         type="text"
//                         name="email"
//                         placeholder="Email"
//                         value={formData.email}
//                         onChange={handleChange}                       
//                         onBlur={handleBlur}
//                       />                      
//                       {errors.email && <p className="error">{errors.email}</p>}
//                     </Form.Group>
//                   </Row>
//                   <Row>
//                     <Form.Group
//                       className="col-md-12 mb-3"
//                       controlId="exampleForm.ControlInput4"
//                     >
//                       <Form.Control
//                         type="text"
//                         name="mobile"
//                         placeholder="Mobile Number"
//                         value={formData.mobile}
//                         onChange={handleMobileChange}                        
//                         onBlur={handleBlur}
//                       />                      
//                       {errors.mobile && (
//                         <p className="error">{errors.mobile}</p>
//                       )}
//                     </Form.Group>
//                   </Row>
//                   <Row>
//                     <Form.Group
//                       className="col-md-12 mb-3"
//                       controlId="exampleForm.ControlInput5"
//                     >
//                       <Form.Control
//                         type="text"
//                         name="city"
//                         placeholder="City"
//                         value={formData.city}
//                         onChange={handleNameChange}                        
//                         onBlur={handleBlur}
//                       />                      
//                       {errors.city && <p className="error">{errors.city}</p>}
//                     </Form.Group>
//                   </Row>

//                   <Row>
//                     <Col md={12}>
//                       <Form.Group>
//                         <Form.Select
//                           className="mb-3 form-control"
//                           name="country"
//                           value={formData.country}
//                           onChange={handleChange}                         
//                           onBlur={handleBlur}
//                         >
//                           <option value="">Country</option>
//                           <option value="Dubai">Dubai</option>
//                         </Form.Select>                        
//                         {errors.country && (
//                           <p className="error">{errors.country}</p>
//                         )}
//                       </Form.Group>
//                     </Col>
//                   </Row>



//            <Row>
//                     <Col md={12}>
//                       <Form.Group>
//                         <Form.Select
//                           className="mb-3 form-control"
//                           name="hearAboutUs"
//                           value={formData.hearAboutUs}
//                           onChange={handleChange}
//                           onBlur={handleBlur}
//                         >
//                           <option value="">Where did you hear about us?</option>
//                           <option value="Referral">Referral</option>
//                           <option value="Google search">Google search</option>
//                           <option value="Social Media">Social Media</option>
//                         </Form.Select>
//                         {errors.hearAboutUs && (
//                           <p className="error">{errors.hearAboutUs}</p>
//                         )}
//                       </Form.Group>
//                     </Col>
//                   </Row>






//                   <Row>
//                     <Form.Group
//                       className="col-md-12 mb-3"
//                       controlId="exampleForm.ControlTextarea1"
//                     >
//                       <Form.Control
//                         as="textarea"
//                         placeholder="Drop Your Message"
//                         name="message"
//                         value={formData.message}
//                         onChange={handleChange}                       
//                         onBlur={handleBlur}
//                         rows={3}
//                       />                      
//                       {errors.message && (
//                         <p className="error">{errors.message}</p>
//                       )}
//                     </Form.Group>
//                   </Row>

//                   <Row>
//                     <Form.Group className="col-md-12 mb-3">
//                       <ReCAPTCHA className="gcaptcha-size"
//                         sitekey="6LeGM28qAAAAAGmZjltF8c4tuHV9F9vxFdjtKPoC"                        
//                         ref={captchaRef}
//                         onChange={(value) => {
//                           setFormData((prevData) => ({
//                             ...prevData,
//                             captchaToken: value,
//                           }));
//                           validateField("captchaToken", value);
//                         }}
//                       />                      
//                       {errors.captchaToken && (
//                         <p className="error gcaptcha-error-msg">{errors.captchaToken}</p>
//                       )}
//                     </Form.Group>
//                   </Row>

//                   <Row className="mt-2 form-btn">
//                     <Col md={12}>
//                       <button type="submit" className="marquis-grey-button">
//                         Submit
//                       </button>
//                     </Col>
//                   </Row>
//                 </Form>
//               </div>
//             </Col>
//           </Row>
//         </Container>
//       </section>

//       {/* Modal Component */}
//       <Modal
//         show={showModal}
//         onHide={handleCloseModal}
//         className="response-popup"
//       >
//         <Modal.Header>
//           <Modal.Title>Thank You!</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>Form Submitted Successfully!</Modal.Body>
//         <Modal.Footer>
//           <button className="marquis-grey-button" onClick={handleCloseModal}>
//             Close
//           </button>
//         </Modal.Footer>
//       </Modal>
//     </Fragment>
//   );
// }

// export default BecomeAgentForm;


import React, { Fragment, useState, useEffect, useRef } from "react";
import { Container, Row, Col, Modal } from "react-bootstrap";
import Form from "react-bootstrap/Form";

import ReCAPTCHA from "react-google-recaptcha";

import * as apiUrl from "../../apiUrl";

import useCountryCode from "../../hooks/useCountryCode";
import CountryCodeField from "../common/CountryCodeField";

function BecomeAgentForm() {
  const [BecomeAgentForm, setBecomeAgentForm] = useState([]);

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    mobile: "",
    countryCode: "+XX",
    city: "",
    country: "",
    message: "",
    hearAboutUs: "",
  });
  const [errors, setErrors] = useState({});
  const [showModal, setShowModal] = useState(false);

  const captchaRef = useRef(null);

  // Same auto-detect pattern as CollectionInnerAbout: auto-fills the dial
  // code when geolocation permission is granted; if denied, falls back to
  // a required dropdown instead (see CountryCodeField).
  const { countryCode, setCountryCode, permissionGranted, locationError } =
    useCountryCode();

  useEffect(() => {
    setFormData((prev) => ({ ...prev, countryCode }));
  }, [countryCode]);

  useEffect(() => {
    if (locationError) {
      setErrors((prev) => ({ ...prev, location: locationError }));
    }
  }, [locationError]);

  useEffect(() => {
    const fetchBecomeAgentForm = async () => {
      try {
        const response = await fetch(
          apiUrl.apiUrl + `/api/become-agent/brokers-form-section`
        );
        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }
        const data = await response.json();
        setBecomeAgentForm(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchBecomeAgentForm();
  }, []);

  const validateField = (fieldName, value) => {
    const namePattern = /^[A-Za-z\s]+$/;
    const mobilePattern = /^[0-9]+$/;
    let error = "";

    switch (fieldName) {
      case "firstName":
        if (!value) error = "Please enter your First Name.";
        else if (!namePattern.test(value))
          error = "First Name should only contain letters.";
        break;

      case "lastName":
        if (!value) error = "Please enter your Last Name.";
        else if (!namePattern.test(value))
          error = "Last Name should only contain letters.";
        break;

      case "email":
        if (!value) error = "Please enter your Email.";
        else if (!/\S+@\S+\.\S+/.test(value)) error = "Email is invalid.";
        break;

      case "mobile":
        if (!value) error = "Please enter your Mobile Number.";
        else if (!mobilePattern.test(value) || value.length < 10)
          error =
            "Mobile Number should only contain numbers and be at least 10 digits.";
        break;

      case "countryCode":
        if (!value) error = "Please Select Contry Code";
        break;

      case "city":
        if (!value) error = "Please enter your City.";
        else if (!namePattern.test(value))
          error = "City should only contain letters.";
        break;

      case "country":
        if (!value) error = "Please select a Country.";
        break;

      case "message":
        if (!value) error = "Please enter a Message.";
        break;

      case "hearAboutUs":
        if (!value) error = "Please select where you heard about us.";
        break;
      case "captchaToken":
        if (!value) error = "Please Select the CAPTCHA.";
        break;

      default:
        break;
    }

    setErrors((prevErrors) => ({ ...prevErrors, [fieldName]: error }));
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;
    validateField(name, value);
  };

  const handleNameChange = (e) => {
    const { name, value } = e.target;
    const namePattern = /^[A-Za-z\s]*$/;

    if (namePattern.test(value)) {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleMobileChange = (e) => {
    const { value } = e.target;
    const mobilePattern = /^[0-9]*$/;

    if (mobilePattern.test(value)) {
      setFormData((prev) => ({ ...prev, mobile: value }));
    }
  };

  const handleCountryCodeSelect = (e) => {
    setCountryCode(e.target.value);
    validateField("countryCode", e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate all fields
    let isValid = true;
    Object.keys(formData).forEach((key) => {
      validateField(key, formData[key]);
      if (errors[key]) {
        isValid = false;
      }
    });

    // Validate reCAPTCHA last
    if (!formData.captchaToken) {
      setErrors((prev) => ({
        ...prev,
        captchaToken: "Please Select the CAPTCHA.",
      }));
      isValid = false;
    }

    if (!isValid) return;

    try {
      const formDataObj = new FormData();
      formDataObj.append("firstName", formData.firstName);
      formDataObj.append("lastName", formData.lastName);
      formDataObj.append("email", formData.email);
      formDataObj.append("countryCode", formData.countryCode);
      formDataObj.append("mobile", formData.countryCode + formData.mobile);
      formDataObj.append("message", formData.message);
      formDataObj.append("city", formData.city);
      formDataObj.append("hearAboutUs", formData.hearAboutUs);
      formDataObj.append("country", formData.country);
      formDataObj.append("captchaToken", formData.captchaToken);

      const response = await fetch(apiUrl.apiUrl + `/api/agent/submit`, {
        method: "POST",
        body: formDataObj,
      });
      const result = await response.json();
      if (result.success) {
        setShowModal(true);
        setFormData({
          firstName: "",
          lastName: "",
          email: "",
          mobile: "",
          countryCode,
          city: "",
          country: "",
          message: "",
          hearAboutUs: "",
          captchaToken: "",
        });

        if (captchaRef.current) {
          captchaRef.current.reset();
        }

        localStorage.removeItem("captchaToken");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleCloseModal = () => setShowModal(false);

  return (
    <Fragment>
      <section className="career-inner-desc-sec become-agent-form-sec">
        <Container fluid>
          <Row className="flex-center career-inner-desc-row">
            <Col md={6} className="padding-zero">
              <div className="career-inner-content-div">
                <h2 className="common-head goldenColor">
                  {BecomeAgentForm.section_title}
                </h2>
                <p className="common-para">
                  {BecomeAgentForm.section_description}​
                </p>
                <img
                  src={`${apiUrl.apiUrl}/${BecomeAgentForm.section_image}`}
                  className="img-fluid career-side-img"
                  alt="Partner with us"
                />
              </div>
            </Col>
            <Col md={6}>
              <div className="career-inner-form-div">
                <Form onSubmit={handleSubmit}>
                  <Row>
                    <Form.Group
                      className="col-md-12 mb-3"
                      controlId="exampleForm.ControlInput1"
                    >
                      <Form.Control
                        type="text"
                        name="firstName"
                        placeholder="First Name"
                        value={formData.firstName}
                        onChange={handleNameChange}
                        onBlur={handleBlur}
                      />
                      {errors.firstName && (
                        <p className="error">{errors.firstName}</p>
                      )}
                    </Form.Group>
                  </Row>
                  <Row>
                    <Form.Group
                      className="col-md-12 mb-3"
                      controlId="exampleForm.ControlInput2"
                    >
                      <Form.Control
                        type="text"
                        name="lastName"
                        placeholder="Last Name"
                        value={formData.lastName}
                        onChange={handleNameChange}
                        onBlur={handleBlur}
                      />
                      {errors.lastName && (
                        <p className="error">{errors.lastName}</p>
                      )}
                    </Form.Group>
                  </Row>
                  <Row>
                    <Form.Group
                      className="col-md-12 mb-3"
                      controlId="exampleForm.ControlInput3"
                    >
                      <Form.Control
                        type="text"
                        name="email"
                        placeholder="Email"
                        value={formData.email}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                      {errors.email && <p className="error">{errors.email}</p>}
                    </Form.Group>
                  </Row>
                  <Row>
                    <Form.Group
                      className="col-md-12 mb-3"
                      controlId="exampleForm.ControlInput4"
                    >
                      <div style={{ display: "flex" }}>
                        <CountryCodeField
                          countryCode={formData.countryCode}
                          onManualSelect={handleCountryCodeSelect}
                          onBlur={handleBlur}
                          permissionGranted={permissionGranted}
                        />
                        <Form.Control
                          type="text"
                          name="mobile"
                          placeholder="Mobile Number"
                          value={formData.mobile}
                          onChange={handleMobileChange}
                          onBlur={handleBlur}
                        />
                      </div>

                      <div style={{ display: "flex" }}>
                        {errors.countryCode && (
                          <p className="error">{errors.countryCode}</p>
                        )}
                        {errors.mobile && (
                          <p className="error">{errors.mobile}</p>
                        )}
                      </div>
                    </Form.Group>
                  </Row>
                  <Row>
                    <Form.Group
                      className="col-md-12 mb-3"
                      controlId="exampleForm.ControlInput5"
                    >
                      <Form.Control
                        type="text"
                        name="city"
                        placeholder="City"
                        value={formData.city}
                        onChange={handleNameChange}
                        onBlur={handleBlur}
                      />
                      {errors.city && <p className="error">{errors.city}</p>}
                    </Form.Group>
                  </Row>

                  <Row>
                    <Col md={12}>
                      <Form.Group>
                        <Form.Select
                          className="mb-3 form-control"
                          name="country"
                          value={formData.country}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        >
                          <option value="">Country</option>
                          <option value="Dubai">Dubai</option>
                        </Form.Select>
                        {errors.country && (
                          <p className="error">{errors.country}</p>
                        )}
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={12}>
                      <Form.Group>
                        <Form.Select
                          className="mb-3 form-control"
                          name="hearAboutUs"
                          value={formData.hearAboutUs}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        >
                          <option value="">Where did you hear about us?</option>
                          <option value="Referral">Referral</option>
                          <option value="Google search">Google search</option>
                          <option value="Social Media">Social Media</option>
                        </Form.Select>
                        {errors.hearAboutUs && (
                          <p className="error">{errors.hearAboutUs}</p>
                        )}
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Form.Group
                      className="col-md-12 mb-3"
                      controlId="exampleForm.ControlTextarea1"
                    >
                      <Form.Control
                        as="textarea"
                        placeholder="Drop Your Message"
                        name="message"
                        value={formData.message}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        rows={3}
                      />
                      {errors.message && (
                        <p className="error">{errors.message}</p>
                      )}
                    </Form.Group>
                  </Row>

                  <Row>
                    <Form.Group className="col-md-12 mb-3">
                      <ReCAPTCHA className="gcaptcha-size"
                        sitekey="6LeGM28qAAAAAGmZjltF8c4tuHV9F9vxFdjtKPoC"
                        ref={captchaRef}
                        onChange={(value) => {
                          setFormData((prevData) => ({
                            ...prevData,
                            captchaToken: value,
                          }));
                          validateField("captchaToken", value);
                        }}
                      />
                      {errors.captchaToken && (
                        <p className="error gcaptcha-error-msg">{errors.captchaToken}</p>
                      )}
                    </Form.Group>
                  </Row>

                  <Row className="mt-2 form-btn">
                    <Col md={12}>
                      <button type="submit" className="marquis-grey-button">
                        Submit
                      </button>
                    </Col>
                  </Row>
                </Form>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Modal Component */}
      <Modal
        show={showModal}
        onHide={handleCloseModal}
        className="response-popup"
      >
        <Modal.Header>
          <Modal.Title>Thank You!</Modal.Title>
        </Modal.Header>
        <Modal.Body>Form Submitted Successfully!</Modal.Body>
        <Modal.Footer>
          <button className="marquis-grey-button" onClick={handleCloseModal}>
            Close
          </button>
        </Modal.Footer>
      </Modal>
    </Fragment>
  );
}

export default BecomeAgentForm;
